import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "./EstadoPago.css";

export default function Success() {
  const history = useHistory();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const status = params.get("status") || "approved";

  const [seconds, setSeconds] = useState(15);

  useEffect(() => {
    const t = setInterval(() => setSeconds(s => (s > 0 ? s - 1 : 0)), 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    if (seconds === 0) history.push("/");
  }, [seconds, history]);

  const goHome = () => history.push("/");
  const goBack = () => (history.length > 1 ? history.goBack() : history.push("/"));

  return (
    <section className="estado-wrap mt-under-header">
      <div className="estado-card estado-success">
        <div className="estado-head">
          <span className="estado-icon" role="img" aria-label="check">✅</span>
          <h1 className="estado-title">Pago aprobado</h1>
        </div>

        <p className="estado-text">
          Gracias por tu compra. En breve recibirás un email con los detalles.
        </p>

        <p className="estado-status"><b>status:</b> {status}</p>

        <div className="estado-actions">
          <button className="btn-outline success" onClick={goHome}>Ir al inicio</button>
          <button className="btn-outline ghost success" onClick={goBack}>Volver</button>
        </div>

        <p className="estado-note">Te redirigimos al inicio en {seconds}s…</p>
      </div>
    </section>
  );
}
